<template>
  <div class="expert">
    <div class="base-content">
      <div class="expert-list m-t-20">
        <div class="el-row" style="margin-left: -10px; margin-right: -10px;" >


          <div @click="toDetail(expert.realname)"   v-for="expert in expertList" class="el-col el-col-6" style="padding-left: 10px; padding-right: 10px;">
            <div class="expert-item">
              <div class="user-info">
                <div class="avatar"><img
                    src="https://patent.jit.edu.cn/patent/userfiles/1/avatar.png">
                </div>
                <div class="expert-info">
                  <div class="name">{{ expert.realname }}</div>
                  <div class="school text-overflow">金陵科技学院</div>
                </div>
              </div>
              <div class="sc">
                <div class="sc-line"></div>
                <div
                    class="scly text-line2"
                     ><p style="white-space:pre-wrap"></p>
                  <p style="white-space:pre-wrap">{{ expert.major1 }}</p>
                  <p style="white-space:pre-wrap"></p></div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>



    <!--分页-->
    <div class="pagination">
      <el-pagination
          :page-size="pageSize"
          :pager-count="10"
          background
          layout="prev, pager, next"
          :total="totalNum"
          :hide-on-single-page="totalNum<=0"
          v-model:current-page="currentPage"
          @current-change="handelCurrentChange"
      />
    </div>



  </div>
</template>

<script>
import {ref} from 'vue'
import {getExpertList} from "@/api/Patent";
import {toRaw} from "@vue/reactivity";
import {useRoute, useRouter} from "vue-router";


export default {
  setup(props) {
    // 获取路由导航对象

    const router = useRouter()

    const toDetail = (id) => {
      const href = router.resolve({ //使用resolve
        path: '/expertDetail/'+id,
      })
      window.open(href.href, '_blank')
    }
    return {toDetail};
  },

  data() {
    return {

      expertList: [],  // 当前显示的知识产权内容
      pageNo: 1,  // 当前页面
      pageSize: 8,  // 每页显示8个
      totalNum: 1000,  // 一共多少条记录
      currentPage: 1, // 当前页
    }
  },
  mounted() {
    this.getExpertList(1);
  },
  methods: {
    // 查询
    async getExpertList(pageNo) {
      let params = {};
      params.pageSize = 8;
      params.pageNo = pageNo;
      let result = await getExpertList(params);
      console.log("查询结果ssss：", result)
      this.expertList = result.rows
      this.totalNum = result.total
    },

    handelCurrentChange(value) {
      console.log("选中的页码：",value)
      this.getExpertList(value)
    },



  }

}
</script>

<style lang="less" scoped>
.expert {
  padding: 40px 0;
}
.expert {
  .base-content {
    width: 1200px;
    margin: 0 auto;
  }
  .base-content {
    .expert-list {
      .expert-item {
        margin-bottom: 30px;
        padding: 20px;
        color: #525252;
        background: #fff;
        box-shadow: 0 0 10px 0 rgba(128,197,255,.26);
        position: relative;
        transition: .4s;
      }
      .expert-item:hover {
        cursor: pointer;
        box-shadow: 0 0 10px 4px rgba(91,150,199,.4);
      }
      .expert-item {
        .user-info {
          display: flex;
        }
        .user-info {
          .avatar {
            width: 92px;
            height: 92px;
            border-radius: 50%;
            border: 6px solid #dbdbdb;
            overflow: hidden;
          }
          .avatar {
            img {
              width: 100%;
              height: 100%;
              -o-object-fit: cover;
              object-fit: cover;
            }
            img {
              width: 100%;
              height: 100%;
              -o-object-fit: cover;
              object-fit: cover;
            }
          }
          .expert-info {
            margin-left: 18px;
            padding: 10px 0;
          }
          .expert-info {
            .name {
              font-size: 28px;
              font-weight: 700;
              margin-bottom: 12px;
            }
            .school {
              max-width: 118px;
              font-size: 16px;
            }
            .name {
              font-size: 28px;
              font-weight: 700;
              margin-bottom: 12px;
            }
            .school {
              max-width: 118px;
              font-size: 16px;
            }
          }
          .avatar {
            width: 92px;
            height: 92px;
            border-radius: 50%;
            border: 6px solid #dbdbdb;
            overflow: hidden;
          }
          .expert-info {
            margin-left: 18px;
            padding: 10px 0;
          }
        }
        .sc {
          margin-top: 15px;
          padding: 20px;
          height: 113px;
          background: url(data:image/png;base64,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) no-repeat 100% 100%;
        }
        .sc {
          .sc-line {
            margin: 5px 20px;
            height: 2px;
            background-color: #2179c8;
            position: relative;
          }
          .sc-line:after {
            content: "\64c5\957f\9886\57df";
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%,-50%);
            background: #fff;
            font-size: 15px;
            font-weight: 700;
            color: #2179c8;
            padding: 0 10px;
          }
          .scly {
            color: #999;
            margin-top: 20px;
          }
          .sc-line {
            margin: 5px 20px;
            height: 2px;
            background-color: #2179c8;
            position: relative;
          }
          .sc-line:after {
            content: "\64c5\957f\9886\57df";
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%,-50%);
            background: #fff;
            font-size: 15px;
            font-weight: 700;
            color: #2179c8;
            padding: 0 10px;
          }
          .scly {
            color: #999;
            margin-top: 20px;
          }
        }
        .exp-tag {
          position: absolute;
          right: 0;
          top: 5px;
          width: 80px;
          height: 25px;
          background: url(data:image/png;base64,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);
          font-size: 14px;
          color: #fff;
          text-align: right;
          line-height: 25px;
          padding-right: 20px;
        }
        .user-info {
          display: flex;
        }
        .sc {
          margin-top: 15px;
          padding: 20px;
          height: 113px;
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPUAAABxCAYAAAANkOWrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE82lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDIxLTEyLTE0VDExOjMyOjMxKzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMS0xMi0xNFQxMTozNzoyMCswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMS0xMi0xNFQxMTozNzoyMCswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6YmVkZTdjYmQtYTM1Yi0zMzRjLWE2MWItYzVjMWZkMWRmNjVhIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOmJlZGU3Y2JkLWEzNWItMzM0Yy1hNjFiLWM1YzFmZDFkZjY1YSIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOmJlZGU3Y2JkLWEzNWItMzM0Yy1hNjFiLWM1YzFmZDFkZjY1YSI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImNyZWF0ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6YmVkZTdjYmQtYTM1Yi0zMzRjLWE2MWItYzVjMWZkMWRmNjVhIiBzdEV2dDp3aGVuPSIyMDIxLTEyLTE0VDExOjMyOjMxKzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+T0/dkwAAA+RJREFUeJzt2T+OHEUcR/HXNW3IIGUDR07YyJEh8gH2ABaBE/5IHAUugRABkgPI9wAEK2fOkEgcICRLE0FAAOouAraGmvaMHSBtt756H6k1sz29q02eflU1w36/p/Me8DnwGfAh8M4wDAzDgKT11VqptQL8BfwMfAd8C/zRnhm6qB8Bz4AHwzBQSjnEvHyVdLduQz56nee5/fwSeArcwH9RPwSugYtSCu3qp7RBS+vqg25Rtwt4BVwBL0b+XXJ/DVzsdjt2ux39pO5jNmxpHS3o9r7Weuh0miamafoA+Ar4ZAQ+Aq766dzC7i9J62tBt6inaaKU0ib3FfDxCDxpxS+X3qUUwAktbUWb2G0/vVyS11qfjMDjNo1LKex2u6Olt3tqaRvadK61HqZzM89z++zxCNzvpzPAudNvSetpQbfX2wOyQ6+39+6PwL1+Kp+a0v0flXT32lReHly3mLte7439ND41mQ1ZWl/f4TLwZbtl+WE7HJO0fae2yeXcJHZCS9v1pm7LqYcMWtq+c82W5Y3+mNy4pe15W69uoKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUhijlsIYtRTGqKUwRi2FMWopjFFLYYxaCmPUUpgCUGs93BiG4fC+vy9pG97Wazn1oDFL23eu2XIuYMOWtutN3R4tv2utzPN8d/+ZpP9lnuejfgHG/kb/vq3Vz63fJd2dU5P5XLsj8Het9d32wTzPDMNwMmaX5NK6liG3Sd2F/ecI/DrP8+UwDJRSDr/Q4m6BO6WldS2DXm6bb7fOv43AT7XWy+V+ukXegnZKS+trHbYJPU3T0bQGbkbgx1rrl20yA69NaKe0tA39lO4ndHdg9sMIPAeu53m+agFP00Qp5bWgjVtax/I76X4/3S29r4Hnw36/B3h4e+OilEK7+qgNWlrXqUOyLuhXwBXwokUN8Ah4Bjxo++ll0IYtrWP5XXQ/qYGXwFPgBqCPGuB94AvgU+ASGN1TS9vRf3UF/AJ8D3wD/N6e+QdA0OMv+puAjwAAAABJRU5ErkJggg==) no-repeat 100% 100%;
        }
        .exp-tag {
          position: absolute;
          right: 0;
          top: 5px;
          width: 80px;
          height: 25px;
          background: url(data:image/png;base64,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);
          font-size: 14px;
          color: #fff;
          text-align: right;
          line-height: 25px;
          padding-right: 20px;
        }
      }
      .expert-item {
        margin-bottom: 30px;
        padding: 20px;
        color: #525252;
        background: #fff;
        box-shadow: 0 0 10px 0 rgba(128,197,255,.26);
        position: relative;
        transition: .4s;
      }
      .expert-item:hover {
        cursor: pointer;
        box-shadow: 0 0 10px 4px rgba(91,150,199,.4);
      }
    }
  }
  .base-content {
    width: 1200px;
    margin: 0 auto;
  }
}

.el-pagination {
  margin-top: 10px;
  justify-content: center; //居中
}
</style>